// volumetry/index.ts
import { ModelType } from '../model-configs';
import { VolumetryCalculator } from './volumetry.interface';
import { prostateVolumetryCalculator } from './prostate-volumetry';

export * from './volumetry.interface';
export { defaultVolumetryCalculator } from './default-volumetry';

const VOLUMETRY_CALCULATORS: Partial<Record<ModelType, VolumetryCalculator>> = {
  prostate: prostateVolumetryCalculator,
  // kidney: kidneyVolumetryCalculator,
};

export function getVolumetryCalculator(modelType: ModelType): VolumetryCalculator | undefined {
  return VOLUMETRY_CALCULATORS[modelType];
}
